export function init_scroll_hint() {

	const scrollhint_button = document.querySelector('.ph-hero-form-widget__scroll-lockup a');
	if (!scrollhint_button) {
		return;
	}

	const scrollhint_target = document.querySelector('.body-wrapper > .section:nth-child(2)');
	scrollhint_target.id = scrollhint_button.getAttribute('href').replace('#', '');
}

export function toggle_alternate_header() {

	const toggle_buttons = document.querySelectorAll('button[data-action=toggle-header]');
	if (!toggle_buttons) return;

	toggle_buttons.forEach((button) =>
	{
		button.addEventListener('click', (e) => {
			e.preventDefault;

			const target_element = document.querySelector('.ph-hero-form-widget');
			target_element.classList.toggle('alternate-active');

			//update address bar URL / browser history
			if (button.getAttribute('data-history-url'))
			{
				window.history.replaceState('', '', button.getAttribute('data-history-url'));
			}
			else
			{
				window.history.replaceState('', '', window.location.pathname);
			}
		});
	});

}




// WEBPACK FOOTER //
// ./scripts/modules/hero-with-form-widget.js